import type { VThemeConfig } from '../VThemeProvider';
import { joinCn } from '../util';
import type { VTreeNodeStatus } from './type';

const style = {
  vTreeItem({
    status: { disabled, expanded: _expanded, selected },
    rounded,
    themeName,
  }: {
    status: VTreeNodeStatus;
    rounded?: boolean;
    themeName?: VThemeConfig['name'];
  }) {
    return {
      container: joinCn(
        'w-full',
        disabled
          ? ['bg-gray-200', 'text-gray-300', 'cursor-not-allowed']
          : ['bg-inherit', 'text-inherit'],
      ),
      name: joinCn(
        'relative',
        'w-fit min-w-full',
        'px-1 py-2',
        'text-body-l',
        'select-none',

        rounded ? 'rounded-md' : 'rounded-none',

        'after:absolute after:top-0 after:left-0',
        'after:h-full after:w-full',
        'after:shadow-sm',
        'after:z-10',
        'after:content-none',
        rounded ? 'after:rounded-md' : 'after:rounded-none',

        !disabled && [
          'cursor-pointer',
          'hover:after:content-[""]',
          selected &&
            (themeName === 'VueFlow' ? 'bg-[#00E88E]/10' : 'bg-tertiary-200'),
        ],
      ),
    };
  },
} as const;

export default style;
